import {
  sendPasswordResetEmail,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential
} from 'firebase/auth'
import { auth } from '../firebase'
import config, { API_JARVIS, API_URL } from '../../config'
import store from '../store'
import { Encrypt } from '../util/aes'
import { order_list_by } from '../util/utils'

export default {
  namespaced: true,
  state: {
    roles: []
  },
  mutations: {
    set_roles(state, payload) {
      order_list_by(payload, 'nombre')
      state.roles = payload
    }
  },
  actions: {
    async getMcpTools({}, userId) {
      const response = await fetch(`${config.API_URL}/user/${encodeURIComponent(userId)}/mcp-tools`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: store.state.token }
      })
      const data = await response.json()
      if (!response.ok || data.exito != 1) throw new Error(data.message || 'No se pudo consultar el acceso MCP.')
      return data
    },
    async saveMcpTools({}, payload) {
      const response = await fetch(`${config.API_URL}/user/${encodeURIComponent(payload.userId)}/mcp-tools`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: store.state.token },
        body: JSON.stringify({ funciones: payload.funciones })
      })
      const data = await response.json()
      if (!response.ok || data.exito != 1) throw new Error(data.message || 'No se pudieron guardar los permisos MCP.')
      return data
    },
    async habilitar_usuario({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/user/${payload.id}/habilitar`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              },
              body: JSON.stringify(payload)
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async inhabilitar_usuario({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/user/${payload.id}/inhabilitar`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              },
              body: JSON.stringify(payload)
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_roles({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/user/${payload.id}/roles`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              },
              body: JSON.stringify(payload)
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_roles_usuario({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/user/${id}/roles`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_roles({ state, commit }) {
      try {
        if (state.roles.length == 0) {
          const res = await fetch(`${config.API_URL}/user/roles`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          if (data.exito == 1) {
            commit('set_roles', data.data)
          } else {
            commit('set_roles', [])
            store.dispatch('show_snackbar', {
              text: data.message,
              color: 'error'
            })
          }
        }
      } catch (error) {
        commit('set_roles', [])
        store.dispatch('show_snackbar', {
          text: error.message,
          color: 'error'
        })
      }
    },
    async get_usuarios({}, filtro) {
      return await new Promise(async (resolve, reject) => {
        try {
          const queryString = [
            `username=${encodeURIComponent(filtro.username || '')}`,
            `email=${encodeURIComponent(filtro.email || '')}`,
            `perfil=${filtro.perfil || null}`,
            `empresa=${filtro.empresa || null}`,
            `inhabilitado=${filtro.inhabilitado ?? 0}`
          ].join('&')
          const res = await fetch(
            `${config.API_URL}/user/search?${queryString}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async buscar_usuarios_sai({}, { empresa_id, q }) {
      return await new Promise(async (resolve, reject) => {
        try {
          const queryString = `empresa_id=${empresa_id}&q=${encodeURIComponent(q)}`
          const res = await fetch(
            `${config.API_URL}/user/sai-search?${queryString}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async get_mecanicos_autodealer({}, empresa_id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const queryString = empresa_id ? `?empresa_id=${empresa_id}` : ''
          const res = await fetch(
            `${config.API_URL}/user/mecanicos-autodealer${queryString}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              }
            }
          )

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async editar_usuario({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/user/${payload.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify(payload)
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async nuevo_usuario({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          let usuario = JSON.parse(JSON.stringify(payload))
          usuario.email = Encrypt(usuario.email)
          usuario.clave = Encrypt(usuario.clave)

          const res = await fetch(`${config.API_URL}/user`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            },
            body: JSON.stringify(usuario)
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async cambiar_clave({}, payload) {
      return await new Promise(async (resolve, reject) => {
        // obtiene las credenciales del usuario para reautenticarlo
        const user = auth.currentUser
        const credential = EmailAuthProvider.credential(
          user.email,
          payload.pass_actual
        )
        await reauthenticateWithCredential(user, credential)
          .then(async () => {
            // actualizamos la contraseña con el usuario reautenticado
            await updatePassword(user, payload.pass_nueva)
              .then(() => {
                resolve()
              })
              .catch(error => {
                switch (error.code) {
                  case 'auth/too-many-requests':
                    error.message =
                      'Superó el límite de intentos de cambio de clave, intente más tarde'
                    break
                }
                reject(error)
              })
          })
          .catch(error => {
            switch (error.code) {
              case 'auth/wrong-password':
                error.message = 'Clave actual incorrecta'
                break
              case 'auth/too-many-requests':
                error.message =
                  'Superó el límite de intentos de cambio de clave, intente más tarde'
                break
            }
            reject(error)
          })
      })
    },
    async recuperar_clave({}, payload) {
      return await new Promise(async (resolve, reject) => {
        await sendPasswordResetEmail(auth, payload)
          .then(() => {
            resolve()
          })
          .catch(error => {
            // cacheamos los errores de firebase para traducirlos
            switch (error.code) {
              case 'auth/user-not-found':
                error.message = 'Email inexistente'
                break
              case 'auth/too-many-requests':
                error.message =
                  'Superó el límite de intentos de recuperación de clave, intente más tarde'
                break
              case 'auth/invalid-email':
                error.message = 'Ingrese un email válido'
                break
            }
            reject(error)
          })
      })
    },
    async get_empresas_usuario({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/user/${id}/empresas`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          resolve(data)
        } catch (error) {
          resolve({
            exito: 0,
            message: error
          })
        }
      })
    },
    async editar_empresas({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/user/${payload.id}/empresas`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              },
              body: JSON.stringify(payload)
            }
          )

          const data = await res.json()

          resolve(data)
        } catch (error) {
          resolve({
            exito: 0,
            message: error
          })
        }
      })
    },

    async altaJarvis({}, payload) {
      const response = await fetch(`${API_JARVIS}/user/altaStark`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.jarvis_token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async updateCuil({}, payload) {
      const response = await fetch(`${API_URL}/user/cuil`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.jarvis_token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getFamiliasDelUsuario({}, payload) {
      const response = await fetch(`${API_URL}/user/familias`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getAreaDelUsuario() {
      const response = await fetch(`${API_URL}/user/area`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    },
    
    async editarAreaDelUsuario({}, payload) {
      const response = await fetch(`${API_URL}/user/area`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })

      return response.json()
    },

    async getAreaPorUsuario({}, payload) {
      const response = await fetch(`${API_URL}/user/area-usuario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })

      return response.json()
    },

    async get_sucursales_usuario({}, id) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/user/${id}/sucursales`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          resolve(data)
        } catch (error) {
          resolve({
            exito: 0,
            message: error
          })
        }
      })
    },

    async editar_sucursales_usuario({}, payload) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(
            `${config.API_URL}/user/${payload.id}/sucursales`,
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                Authorization: store.state.token
              },
              body: JSON.stringify(payload)
            }
          )

          const data = await res.json()

          resolve(data)
        } catch (error) {
          resolve({
            exito: 0,
            message: error
          })
        }
      })
    },

    async get_mcp_credenciales({}, userId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/mcp/oauth/clients/${userId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },

    async generar_mcp_credenciales({}, userId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/mcp/oauth/clients/${userId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },

    async revocar_mcp_credenciales({}, userId) {
      return await new Promise(async (resolve, reject) => {
        try {
          const res = await fetch(`${config.API_URL}/mcp/oauth/clients/${userId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: store.state.token
            }
          })

          const data = await res.json()

          if (data.exito == 1) {
            resolve(data)
          } else {
            reject(data)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
  }
}
